import auth from "./auth.js";
import otp from "./otp.js";
import user from "./user.js";
import publication from "./publication.js";
import studio from "./studio.js";
import analytics from "./analytics.js";
import folder from "./folder.js";
import errors from "./errors.js";
import access from "./access.js";

export default { auth, otp, user, publication, studio, analytics, folder, errors, access };
